import { callApi } from "./Api";
import { actionCreator } from "./helpers";
import { getClientTags } from "./Clients";

export const SAVE_INSIGHTS_FILE_SETUP = "SAVE_INSIGHTS_FILE_SETUP";
export const SET_SETTINGS_WEBSITE_ID = "SET_SETTINGS_WEBSITE_ID";
export const CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR =
  "CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR";
export const setSettingsWebsiteId = actionCreator(SET_SETTINGS_WEBSITE_ID);
export const clearInsightsFileSettingsSaveError = actionCreator(
  CLEAR_INSIGHTS_FILE_SETTINGS_SAVE_ERROR,
);

export const saveInsightsFileSetup = (client_id, tag_id, obj) => {
  return (dispatch, getState) => {
    const url = `insights/${tag_id}/insights-file-setup`;
    callApi(
      dispatch,
      getState,
      SAVE_INSIGHTS_FILE_SETUP,
      url,
      {
        method: "POST",
        body: JSON.stringify(obj),
      },
      {
        success: () => {
          dispatch(getClientTags(client_id));
        },
      },
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/settings.js